import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { StudioRoot } from "./app/StudioRoot";
import { StoryPreferencesProvider } from "./i18n";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("Story Studio root element is missing.");

createRoot(root).render(
  <StrictMode>
    <StoryPreferencesProvider><StudioRoot /></StoryPreferencesProvider>
  </StrictMode>,
);
